export enum BoardType {
    Task,
    Transparency,
    Whiteboard
}
